import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

import { IAppState } from 'config/redux/reducers';

import { IDeliverySlotState } from '../redux/deliverySlot.reducer';
import {
  toggleVisibility,
  toggleCoachMark,
  toggleDrawerCoachMark,
} from '../redux/deliverySlot.action';

const useDeliverySlot = (): [
  IDeliverySlotState,
  {
    showDeliverySlot: () => any;
    hideDeliverySlot: () => any;
    showCoachMark(): any;
    hideCoachMark(): any;
    hideDrawerCoachMark(): any;
  }
] => {
  const dispatch = useDispatch();
  const deliverySlotState = useSelector(({ deliverySlot }: IAppState) => deliverySlot);

  const showDeliverySlot = useCallback(() => dispatch(toggleVisibility(true)), [dispatch]);
  const hideDeliverySlot = useCallback(() => dispatch(toggleVisibility(false)), [dispatch]);
  const hideCoachMark = useCallback(() => dispatch(toggleCoachMark()), [dispatch]);
  const showCoachMark = useCallback(() => dispatch(toggleCoachMark(true)), [dispatch]);
  const hideDrawerCoachMark = useCallback(() => dispatch(toggleDrawerCoachMark()), [dispatch]);

  return [
    deliverySlotState,
    { showDeliverySlot, hideDeliverySlot, showCoachMark, hideCoachMark, hideDrawerCoachMark },
  ];
};

export default useDeliverySlot;
